// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"39059":"9d9feace","50502":"c3a71a48","56367":"ab01d938","73582":"4fbedf4a","75120":"b7fb093b"}[chunkId] + ".chunk.css";
};